<template>
    <basic-header pretitle="aqfer Graph Manager" title="Job Stack Deployments" />

    <div class="container-fluid">
        <div v-if="sandBoxListOptions.length">
            <input-field label="Choose a Sandbox" type="select" :options="sandBoxListOptions"
                v-model="selectedSandbox" />
            <div class="card">
                <datatable tableId="deploymentsTable" :columns="columns" uniqueField="id" :orderColumn="orderColumn" :showLoading="loading"
                    :data="deployments" :compact="true" :ignoreCache="true"
                    :detailColumn="{ 
                        renderBaseUrl: (data) => {
                            return `/${$route.params.cid}/agm/sandbox/${$route.params.sandboxId}/deployments/`;
                        }, 
                        name: 'Job Stack Deployment Pipeline Edit', 
                        identifier: 'id' 
                    }" />
            </div>
        </div>
        <div v-else-if="!loading && !sandBoxListOptions.length" class="container-fluid">
            <div class="alert alert-secondary" role="alert">
                No Sandboxes available!
            </div>
        </div>
        <div v-else class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import InputField from "../../components/InputField.vue";
import Datatable from "../../components/Datatable.vue";
import { mapActions } from "vuex";

export default {
    name: "Job Stack Deployments List",
    components: { BasicHeader, Datatable, InputField },
    data() {
        return {
            columns: [
                { data: "id" },
                { data: "name" },
                { data: "job_stack", title: "Job Stack" },
                { data: "deployed_by", title: "Deployed By" },
                { data: "deployed_at", title: "Deployed At" },
            ],
            orderColumn: [4, "desc"],
            loading: true,
            deployments: null,
        };
    },
    computed: {
        selectedSandbox: {
            get() {
                return this.$store.state.sandbox.currentSandbox;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch('sandbox/setCurrentSandbox', value);
                    this.$router.push({
                        name: "Job Stack Deployments List",
                        params: {
                            cid: this.$route.params.cid || this.$store.state.currentClient.cid,
                            sandboxId: `${value}`
                        },
                    });
                }
            }
        },
        sandBoxListOptions() {
            return this.$store.state.sandbox.devSandboxes ? this.$store.state.sandbox.devSandboxes.map((sandbox) => {
                return { "label": `${sandbox.name} - ${sandbox.env}`, "value": sandbox.name };
            }) : [];
        }
    },
    methods: {
        ...mapActions({
            fetchJobStackDeployments: "amdp/fetchJobStackDeployments",
        }),
        async fetchDeployments() {
            if (!this.selectedSandbox) {
                return;
            }
            this.loading = true;
            this.deployments = null;

            await this.fetchJobStackDeployments(this.selectedSandbox).then(response => {
                this.deployments = response.data;
            }).catch(error => {
                console.error("Error fetching job stack deployments: ", error);
                let err = error.response?.data?.error ? error.response.data.error : error.message;
                this.$store.dispatch("addToast", {
                    message: err || "Something went wrong when fetching job stack deployments. Please contact support.",
                    type: "error",
                });
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    async beforeMount() {
        // Set sandbox from route params if available
        const sandboxIdFromRoute = this.$route.params.sandboxId;
        if (sandboxIdFromRoute) {
            this.$store.dispatch('sandbox/setCurrentSandbox', sandboxIdFromRoute);
            await this.fetchDeployments();
        } else {
            // If no sandboxId in route, wait for sandboxes to load and let watcher handle it
            // The computeNavRoute should have set it, but this is a fallback
            const sandboxes = this.$store.state.sandbox.sandboxes || [];
            if (sandboxes.length > 0) {
                const initialSandbox = sandboxes[0].name;
                this.$store.dispatch('sandbox/setCurrentSandbox', initialSandbox);
                this.$router.push({
                    name: "Job Stack Deployments List",
                    params: {
                        cid: this.$route.params.cid || this.$store.state.currentClient.cid,
                        sandboxId: initialSandbox
                    },
                });
            }
        }
    }
};
</script>

<style scoped>
</style>